module.exports = __webpack_public_path__ + "static/media/robert-beard-danielle-roossien-workshop.abb79a86.webp";